// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner-module--spinner--3IFPn","rotation":"spinner-module--rotation--1FTxl","spinnerHarness":"spinner-module--spinnerHarness--3Ojk2"};